export const stripeElementsConfig = {
  mode: 'payment',
  captureMethod: 'manual',
  paymentMethodCreation: 'manual',
  defaultStripeCurrency: 'usd',
  allowedCardBrands: ['visa', 'mastercard', 'american_express'],
};

export const STRIPE_ACCOUNT_COUNTRY_CODE = 'GB';

export const STRIPE_SETUP_MODE = 'setup';

export const allowedCardBrandsOrder = ['amex', 'visa', 'mastercard'];

export const STRIPE = 'STRIPE';

export const STRIPE_LOAD_TYPES = {
  loadCheckoutStripe: 'LOAD_CHECKOUT_STRIPE',
  loadPaymentMethodStripe: 'LOAD_PAYMENT_METHOD_STRIPE',
};

export const contextKeysFor3DSAuth = {
  merchantData: 'MerchantData',
  paymentReferenceId: 'PaymentReferenceId',
};

export const paymentIntentType = {
  type: 'payment_intent',
  handlerName: 'handlePaymentIntentCardAction',
};

export const setUpIntentType = {
  type: 'setup_intent',
  handlerName: 'handleSetUpIntentCardAction',
};

/** Formula1 Font URLs can be found at https://www.formula1.com/en.html - under the devtools network tab and selecting the All Menu and then search for Formula1-Regular/Titillium+Web. */

/** https://stripe.com/docs/js/appendix/custom_font_source_object */

export const FORMULA_ONE_REGULAR_FONT_URL = `https://www.formula1.com/etc/designs/fom-website/fonts/F1Regular/Formula1-Regular.woff`;

/** https://stripe.com/docs/js/appendix/css_font_source_object */

export const TITILLIUM_WEB_FONT_URL =
  'https://fonts.googleapis.com/css?family=Titillium+Web:400,400i,600,600i';
